export default class InvestigatorListController {
  constructor($state, Group, UIService, Investigador, InvestigatorService, Pais, Genero, Publicacao, PublicacaoService, AuthorizationService, AuthenticationService) {
    this.$state = $state;
    this.Group = Group;
    this.UI = UIService;
    this.Investigador = Investigador;
    this.InvestigatorService = InvestigatorService;
    this.Pais = Pais;
    this.Genero = Genero;
    this.Publicacao = Publicacao;
    this.PublicacaoService = PublicacaoService;
    this.canReadPrivate = AuthorizationService.canPerform('investigadorReadPrivateAny');
    this.user = AuthenticationService.getUser();

    this.dataLoaded = false;

    this.simnao = [{ name: "Sim", value: 1 }, { name: "Não", value: 0 }];
    this.generos = [];
    this.nacionalidades = [];
    this.superioresHierarquicos = [];
    this.filtersLoaded = [1, 0, 0, 0];

    this.opt = $state.params;

    if (this.canReadPrivate) {
      this.displayColumns = [
        { displayName: 'ID SGI', name: 'id', visible: false, sortable: true },
        { displayName: 'Nome', name: 'nome', visible: true, sortable: true },
        { displayName: 'Nome Preferido', name: 'nomePreferido', visible: false, sortable: true },
        { displayName: 'Slug', name: 'slug', visible: false, sortable: true },
        { displayName: 'Superior Hierárquico 1', name: 'superiorHierarquico1', visible: true, sortable: true },
        { displayName: 'Superior Hierárquico 2', name: 'superiorHierarquico2', visible: true, sortable: true },
        { displayName: 'ORCID ID', name: 'orcidId', visible: true, sortable: true },
        { displayName: 'Researcher ID', name: 'researcherId', visible: false, sortable: true },
        { displayName: 'Google Scholar', name: 'googleScholar', visible: false, sortable: true },
        { displayName: 'Degóis', name: 'degois', visible: false, sortable: true },
        { displayName: 'Ciência ID', name: 'cienciaId', visible: false, sortable: true },
        { displayName: 'SCOPUS ID', name: 'scopusId', visible: false, sortable: true },
        { displayName: 'Descrição', name: 'descricao', visible: false, sortable: true },
        { displayName: 'Género', name: 'genero', visible: false, sortable: true },
        { displayName: 'Nacionalidade', name: 'nacionalidade', visible: true, sortable: true },
        { displayName: 'Data de Nascimento', name: 'dataNascimento', exportDate: 'DD-MM-YYYY', sortable: true, visible: false },
        { displayName: 'Email', name: 'email', visible: true, sortable: false },
        { displayName: 'Email Alternativo', name: 'emailAlternativo', visible: false, sortable: false },
        { displayName: 'Contacto Telefónico', name: 'contactoTelefonico', visible: false, sortable: false },
        { displayName: 'Contacto Interno', name: 'contactoInterno', visible: false, sortable: false },
        { displayName: 'Gabinete', name: 'gabinete', visible: false, sortable: false },
        { displayName: 'Website', name: 'website', visible: false, sortable: false },
        { displayName: 'Completo', name: 'ok', visible: true, sortable: true }
      ];
    } else {
      this.displayColumns = [
        { displayName: 'ID SGI', name: 'id', visible: false, sortable: true },
        { displayName: 'Nome', name: 'nome', visible: true, sortable: true },
        { displayName: 'Nome Preferido', name: 'nomePreferido', visible: false, sortable: true },
        { displayName: 'Slug', name: 'slug', visible: false, sortable: true },
        { displayName: 'Superior Hierárquico 1', name: 'superiorHierarquico1', visible: false, sortable: true },
        { displayName: 'Superior Hierárquico 2', name: 'superiorHierarquico2', visible: false, sortable: true },
        { displayName: 'ORCID ID', name: 'orcidId', visible: true, sortable: true },
        { displayName: 'Researcher ID', name: 'researcherId', visible: false, sortable: true },
        { displayName: 'Google Scholar', name: 'googleScholar', visible: false, sortable: true },
        { displayName: 'Degóis', name: 'degois', visible: false, sortable: true },
        { displayName: 'Ciência ID', name: 'cienciaId', visible: false, sortable: true },
        { displayName: 'SCOPUS ID', name: 'scopusId', visible: false, sortable: true },
        { displayName: 'Descrição', name: 'descricao', visible: false, sortable: true },
        { displayName: 'Email', name: 'email', visible: true, sortable: false },
        { displayName: 'Contacto Interno', name: 'contactoInterno', visible: false, sortable: false },
        { displayName: 'Gabinete', name: 'gabinete', visible: false, sortable: false },
        { displayName: 'Website', name: 'website', visible: false, sortable: false },
        { displayName: 'Completo', name: 'ok', visible: true, sortable: true }
      ];
    }

    // type 's': select, 'o': plain text, 'd': date
    this.equalityFilters = [{
      val: 'a',
      name: 'Igual',
      type: 'o'
    },
      {
        val: 'b',
        name: 'Diferente',
        type: 'o'
      },
      {
        val: 'c',
        name: 'Começa por',
        type: 'o'
      },
      {
        val: 'd',
        name: 'Termina com',
        type: 'o'
      },
      {
        val: 'e',
        name: 'Contém',
        type: 'o'
      },
      {
        val: 'a',
        name: 'Igual (=)',
        type: 'd'
      },
      {
        val: 'b',
        name: 'Diferente de (≠)',
        type: 'd'
      },
      {
        val: 'c',
        name: 'Posterior a (>)',
        type: 'd'
      },
      {
        val: 'd',
        name: 'Anterior a (<)',
        type: 'd'
      },
      {
        val: 'e',
        name: 'Posterior ou igual (≥)',
        type: 'd'
      },
      {
        val: 'f',
        name: 'Anterior ou igual (≤)',
        type: 'd'
      },
      {
        val: 'a',
        name: 'Igual',
        type: 's'
      },
      {
        val: 'b',
        name: 'Diferente',
        type: 's'
      }
    ];

    this.dateFilters = this.equalityFilters.filter(x => x.type === 'd');

    if (this.canReadPrivate) {
      this.columns = [{
        id: 'Investigador.id',
        name: 'ID SGI',
        type: 'o'
      },
        {
          id: 'Investigador.nome',
          name: 'Nome',
          type: 'o'
        },
        {
          id: 'Investigador.nomePreferido',
          name: 'Nome Preferido',
          type: 'o'
        },
        {
          id: 'Investigador.slug',
          name: 'Slug',
          type: 'o'
        },
        {
          id: 'Investigador.superiorHierarquico1Id',
          name: 'Superior Hierárquico 1',
          type: 's',
          list: this.superioresHierarquicos
        },
        {
          id: 'Investigador.superiorHierarquico2Id',
          name: 'Superior Hierárquico 2',
          type: 's',
          list: this.superioresHierarquicos
        },
        {
          id: 'Investigador.orcidId',
          name: 'ORCID ID',
          type: 'o'
        },
        {
          id: 'Investigador.dataNascimento',
          name: 'Data de Nascimento',
          type: 'd',
          format: "YYYY-MM-DD",
          displayFormat: "DD/MM/YYYY"
        },
        {
          id: 'Investigador.email',
          name: 'Email',
          type: 'o'
        },
        {
          id: 'Investigador.emailAlternativo',
          name: 'Email Alternativo',
          type: 'o'
        },
        {
          id: 'Investigador.contactoTelefonico',
          name: 'Contacto Telefónico',
          type: 'o'
        },
        {
          id: 'Investigador.contactoInterno',
          name: 'Contacto Interno',
          type: 'o'
        },
        {
          id: 'Investigador.gabinete',
          name: 'Gabinete',
          type: 'o'
        },
        {
          id: 'Investigador.website',
          name: 'Website',
          type: 'o'
        },
        {
          id: 'Investigador.researcherId',
          name: 'Researcher ID',
          type: 'o'
        },
        {
          id: 'Investigador.googleScholar',
          name: 'Google Scholar',
          type: 'o'
        },
        {
          id: 'Investigador.degois',
          name: 'Degóis',
          type: 'o'
        },
        {
          id: 'Investigador.cienciaId',
          name: 'Ciência ID',
          type: 'o'
        },
        {
          id: 'Investigador.scopusId',
          name: 'SCOPUS ID',
          type: 'o'
        },
        {
          id: 'Investigador.descricao',
          name: 'Descrição',
          type: 'o'
        },
        {
          id: 'Investigador.nacionalidadeId',
          name: 'Nacionalidade',
          type: 's',
          list: this.nacionalidades
        },
        {
          id: 'Investigador.generoId',
          name: 'Género',
          type: 's',
          list: this.generos
        },
        {
          id: 'Investigador.ok',
          name: 'Completo',
          type: 's',
          list: this.simnao
        }
      ];
    } else {
      this.columns = [{
        id: 'Investigador.id',
        name: 'ID SGI',
        type: 'o'
      },
        {
          id: 'Investigador.nome',
          name: 'Nome',
          type: 'o'
        },
        {
          id: 'Investigador.nomePreferido',
          name: 'Nome Preferido',
          type: 'o'
        },
        {
          id: 'Investigador.slug',
          name: 'Slug',
          type: 'o'
        },
        {
          id: 'Investigador.superiorHierarquico1Id',
          name: 'Superior Hierárquico 1',
          type: 's',
          list: this.superioresHierarquicos
        },
        {
          id: 'Investigador.superiorHierarquico2Id',
          name: 'Superior Hierárquico 2',
          type: 's',
          list: this.superioresHierarquicos
        },
        {
          id: 'Investigador.orcidId',
          name: 'ORCID ID',
          type: 'o'
        },
        {
          id: 'Investigador.email',
          name: 'Email',
          type: 'o'
        },
        {
          id: 'Investigador.researcherId',
          name: 'Researcher ID',
          type: 'o'
        },
        {
          id: 'Investigador.googleScholar',
          name: 'Google Scholar',
          type: 'o'
        },
        {
          id: 'Investigador.degois',
          name: 'Degóis',
          type: 'o'
        },
        {
          id: 'Investigador.cienciaId',
          name: 'Ciência ID',
          type: 'o'
        },
        {
          id: 'Investigador.scopusId',
          name: 'SCOPUS ID',
          type: 'o'
        },
        {
          id: 'Investigador.contactoInterno',
          name: 'Contacto Interno',
          type: 'o'
        },
        {
          id: 'Investigador.gabinete',
          name: 'Gabinete',
          type: 'o'
        },
        {
          id: 'Investigador.website',
          name: 'Website',
          type: 'o'
        },
        {
          id: 'Investigador.ok',
          name: 'Completo',
          type: 's',
          list: this.simnao
        }
      ];
    }


    // Find relevant displayColumns from local storage
    if (localStorage.getItem('ISR_SGI_DisplayColumns')) {
      let displayColumns = JSON.parse(localStorage.getItem('ISR_SGI_DisplayColumns'));
      if (displayColumns && displayColumns.investigador && displayColumns.investigador.length > 0) {
        displayColumns.investigador.forEach(c => {
          let i = this.displayColumns.findIndex(x => x.name === c.name);
          if (i >= 0) this.displayColumns[i].visible = c.visible;
        });
      }
    }

    this.customFilters = [];

    // Find customFilters from local storage
    if (localStorage.getItem('ISR_SGI_Filters')) {
      let storageFilters = JSON.parse(localStorage.getItem('ISR_SGI_Filters'));
      if (storageFilters.investigador) this.customFilters = storageFilters.investigador;
    }

    // Check if something comes from the URL, replace the customFilters if so
    if (this.opt.filter) {
      this.customFilters = [];
      let filters = this.opt.filter.split(":");
      filters.forEach(filter => {
        let a = filter.split("·");
        if (a.length === 3) {
          try {
            let data = {
              column: {},
              value: {}
            };
            data.column.selected = this.columns.find(f => {
              return f.id === a[0];
            });
            if (angular.isUndefined(data.column.selected)) {
              throw Error();
            }
            this.customFilters.push(data);
          } catch (e) {
            this.customFilters = [];
            this.UI.addToast('Não foi possível carregar filtros');
          }
        }
      });
      // If updated, save it to local storage
      this.setToLocalStorage('ISR_SGI_Filters', 'investigador', this.customFilters);
    }

    // Restore list to selected if exists
    this.customFilters.forEach(f => {
      if (f.column && f.column.selected) {
        if (f.column && f.column.selected) {
          if (f.column.selected.id === 'Investigador.nacionalidadeId')
            f.column.selected.list = this.nacionalidades;
          if (f.column.selected.id === 'Investigador.generoId')
            f.column.selected.list = this.generos;
          if (f.column.selected.id === 'Investigador.ok')
            f.column.selected.list = this.simnao;
          if (f.column.selected.id === 'Investigador.superiorHierarquico1Id')
            f.column.selected.list = this.superioresHierarquicos;
          if (f.column.selected.id === 'Investigador.superiorHierarquico2Id')
            f.column.selected.list = this.superioresHierarquicos;
        }
      }
      // Fix date filters to be moment()
      if (f.column.selected.type === 'd') {
        f.value = moment(f.value).utc();
        f.value.second(0); // We don't care about seconds
      }
    });

    // Number of selected items
    this.nSelected = 0;
    this.everythingSelected = false;

    // Load the data for the filter panel (not mandatory just to look at the table)
    this.loadData();
    // Load the table data so we can see stuff even if nothing else works
    this.getInvestigadores();
  }

  // Set to localStorage storageKey, to the value with the content for that value
  setToLocalStorage = (storageKey, value, content) => {
    let s = JSON.parse(localStorage.getItem(storageKey));
    if (s) { // If storageKey exists, check if value exists
      if (s[value]) {
        if (content) {
          s[value] = content;
        } else {
          delete s[value];
        }
      } else {
        if (content) {
          s[value] = content;
        } else {
          // Nothing...
        }
      }
    } else {
      if (content) {
        s = {};
        s[value] = content;
      } else {
        // Nothing...
      }
    }
    localStorage.setItem(storageKey, JSON.stringify(s));
  };



  // Add entry to whereObject (where/whereLiteral) or to whereOrObject depending if there are multiple selections of the same entry
  setWhereField = (data, whereObject, whereOrObject) => {
    // Check if have this entry in whereOr already
    if (whereOrObject.find(x => x.key === data.key)) { // If so, add it here then
      whereOrObject.push({
        key: data.key,
        value: data.value
      });
    } else { // Not in OR, check if there's an entry of this key in whereObject already
      if (whereObject[data.key]) { // Already have an entry for this key, transform it into an OR and add it and the new one
        whereOrObject.push({
          key: data.key,
          value: whereObject[data.key]
        });
        delete whereObject[data.key];
        whereOrObject.push({
          key: data.key,
          value: data.value
        });
      } else { // It's the first entry of this key, use whereObject only
        whereObject[data.key] = data.value;
      }
    }
  };

  // Returns a whereFields object to use in table() remote methods
  // WhereLiteral should be defined locally
  setWhereFields = (customFilters, literal, orsLiteral) => {
    let where = {};
    let whereDates = [];
    let whereNextDates = [];
    let whereLiteral = literal || {};
    let whereOrLiteral = orsLiteral || [];
    let whereOr = [];

    customFilters.forEach(f => {
      let data = {};
      data.key = f.column.selected.id;
      // Generated dates - Assuming if no . exists in field, it's always generated date
      if (f.column.selected.id.split('.').filter(Boolean).length === 1 && f.column.selected.type === 'd') {
        whereNextDates.push({
          key: data.key,
          comp: f.values.selected.val,
          value: f.value,
          format: f.column.selected.format
        });
      } else { // All other cases where fields exist in database
        if (f.column.selected.type === 'o') {
          data.value = f.value;

          this.setWhereField(data, where, whereOr);
        } else {
          if (f.column.selected.type === 'd') {
            whereDates.push({
              key: data.key,
              comp: f.values.selected.val,
              value: f.value,
              format: f.column.selected.format
            });
          } else {
            // if ID doesn't exist, use value (Yes/No cases where id doesn't exist but value does)
            if (f.value.selected.id)
              data.value = f.value.selected.id;
            else
              data.value = f.value.selected.value;

            this.setWhereField(data, whereLiteral, whereOrLiteral);
          }
        }
      }
    });
    return {
      where: where,
      whereDates: whereDates,
      whereNextDates: whereNextDates,
      whereLiteral: whereLiteral,
      whereOr: whereOr,
      whereOrLiteral: whereOrLiteral
    };
  };

  clearFilter = () => {
    this.setToLocalStorage('ISR_SGI_Filters', 'investigador', null);
    this.customFilters = [];
    this.getInvestigadores();
  };

  getInvestigadores = () => {
    this.tableLoading = true;

    let whereFields = this.setWhereFields(this.customFilters);

    let fields;
    if (this.canReadPrivate) {
      fields = [ // edit exportInvestigadores() too
        'Investigador.id as id',
        'Investigador.userId as userId',
        'Investigador.nome as nome',
        'Investigador.nomePreferido as nomePreferido',
        'Investigador.slug as slug',
        'Investigador.orcidId as orcidId',
        'Investigador.dataNascimento as dataNascimento',
        'Investigador.email as email',
        'Investigador.emailAlternativo as emailAlternativo',
        'Investigador.contactoTelefonico as contactoTelefonico',
        'Investigador.researcherId as researcherId',
        'Investigador.googleScholar as googleScholar',
        'Investigador.degois as degois',
        'Investigador.cienciaId as cienciaId',
        'Investigador.scopusId as scopusId',
        'Investigador.ok as ok',
        'Genero.designacao as genero',
        'Pais.nome as nacionalidade',
        'Investigador.superiorHierarquico1Id as superiorHierarquico1Id', // For searches
        'Investigador.superiorHierarquico2Id as superiorHierarquico2Id', // For searches
        'Investigador2.nomePreferido as superiorHierarquico1',
        'Investigador3.nomePreferido as superiorHierarquico2'
      ];
    } else {
      fields = [ // edit exportInvestigadores() too
        'Investigador.id as id',
        'Investigador.userId as userId',
        'Investigador.nome as nome',
        'Investigador.nomePreferido as nomePreferido',
        'Investigador.slug as slug',
        'Investigador.orcidId as orcidId',
        'Investigador.email as email',
        'Investigador.researcherId as researcherId',
        'Investigador.googleScholar as googleScholar',
        'Investigador.degois as degois',
        'Investigador.cienciaId as cienciaId',
        'Investigador.scopusId as scopusId',
        'Investigador.contactoInterno as contactoInterno',
        'Investigador.gabinete as gabinete',
        'Investigador.website as website',
        'Investigador.ok as ok',
        'Investigador.superiorHierarquicoId as superiorHierarquicoId', // For searches
        'Investigador2.nomePreferido as superiorHierarquico1',
        'Investigador3.nomePreferido as superiorHierarquico2'
      ];
    }

    this.Investigador.table({
      params: {
        fields: fields,
        from: ['Investigador', 'Genero', 'Pais', 'Investigador', 'Investigador'],
        references: [undefined, 'Investigador.generoId', 'Investigador.nacionalidadeId', 'Investigador.superiorHierarquico1Id', 'Investigador.superiorHierarquico2Id'],
        aliases: [null, null, null, 'Investigador2', 'Investigador3'],
        where: whereFields.where,
        whereLiteral: whereFields.whereLiteral,
        whereDates: whereFields.whereDates,
        whereOr: whereFields.whereOr,
        whereOrLiteral: whereFields.whereOrLiteral,
        order: this.opt.order,
        sort: this.opt.sort,
        limit: this.opt.items,
        skip: (this.opt.page - 1) * this.opt.items,
      }
    }).$promise.then(res => {
      let page = this.opt.page;
      let items = this.opt.items;

      let total = res.count;

      this.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.start - 1 + items) >= total) {
        this.end = total;
      } else {
        this.end = Number.parseInt(this.start - 1 + items);
      }

      // Process output
      res.data.forEach(i => {

      });

      this.investigadores = res.data;
      this.total = total;
      this.tableLoading = false;
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Erro na busca de investigadores. Verifique a ligação");
    });
  };

  isColumnVisible = (column) => {
    let f = this.displayColumns.find(x => x.name === column);
    return _.isEmpty(f) ? false : f.visible;
  };

  selectVisibleColumns = () => {
    let options = {
      size: 'md',
      template: require('./columns.dialog.html'),
      controller: ['$dialog', '$scope', (dialog, scope) => {
        scope.title = "Editar Campos Visíveis";
        scope.displayColumns = angular.copy(this.displayColumns);

        scope.ok = () => {
          dialog.close(scope);
        };

        scope.cancel = () => {
          dialog.dismiss('cancel');
        };
      }]
    };

    let modal = this.UI.showDialog(options);

    modal.then((res) => {
      if (res && res.displayColumns) {
        this.displayColumns = angular.copy(res.displayColumns);
        // Save it to local storage
        this.setToLocalStorage('ISR_SGI_DisplayColumns', 'investigador', this.displayColumns);
      }
    });
  };

  loadData = () => {
    this.Genero.find({
    }).$promise.then(generos => {
      generos.forEach(t => {
        t.name = t.designacao;
      });
      this.generos = generos;
      this.filtersLoaded[1] = 1;
    }).catch(e => {
      this.generos = [];
      this.filtersLoaded[1] = 1;
      this.UI.addToast("Erro de carregamento de dados para filtragem (Géneros).");
    });

    this.Pais.find({
      filter: {
        order: 'ordem ASC'
      }
    }).$promise.then(nacionalidades => {
      nacionalidades.forEach(t => {
        t.name = t.nome;
      });
      this.nacionalidades = nacionalidades;
      this.filtersLoaded[2] = 1;
    }).catch(e => {
      this.nacionalidades = [];
      this.filtersLoaded[2] = 1;
      this.UI.addToast("Erro de carregamento de dados para filtragem (Nacionalidades).");
    });

    this.Investigador.find({}).$promise.then(superioresHierarquicos => {
      superioresHierarquicos.sort((a, b) => a.nome.localeCompare(b.nome));
      superioresHierarquicos.forEach(i => {
      i.name = i.nome;
      });
      this.superioresHierarquicos = superioresHierarquicos;
      this.filtersLoaded[3] = 1;
    }).catch(e => {
      this.superioresHierarquicos = [];
      this.filtersLoaded[3] = 0;
      this.UI.addToast("Erro no carregamento de dados para filtragem (Superiores Hierárquicos).");
    });
  };

  sort = key => {
    if (!key.sortable) {
      return;
    }
    let keyname = key.name;
    if (this.opt.order === keyname)
      this.opt.page = 1;
    this.opt.order = keyname;
    this.opt.sort = this.opt.sort === 'asc' ? 'desc' : 'asc';
    this.$state.go('app.investigator.list', this.opt, {
      // prevent the events onStart and onSuccess from firing
      notify: false,
      // prevent reload of the current state
      reload: false,
      // replace the last record when changing the params so you don't hit the back button and get old params
      location: 'replace',
      // inherit the current params on the url
      inherit: true
    });
    this.getInvestigadores();
  };

  item = val => {
    this.opt.items = val;
    this.$state.go('app.investigator.list', this.opt, {
      // prevent the events onStart and onSuccess from firing
      notify: false,
      // prevent reload of the current state
      reload: false,
      // replace the last record when changing the params so you don't hit the back button and get old params
      location: 'replace',
      // inherit the current params on the url
      inherit: true
    });
    this.getInvestigadores();
  };

  page = sum => {
    this.opt.page += sum;
    if (this.opt.page < 1)
      this.opt.page = 1;
    if (this.opt.page > Math.ceil(this.total / this.opt.items))
      this.opt.page = Math.ceil(this.total / this.opt.items);
    this.$state.go('app.investigator.list', this.opt, {
      // prevent the events onStart and onSuccess from firing
      notify: false,
      // prevent reload of the current state
      reload: false,
      // replace the last record when changing the params so you don't hit the back button and get old params
      location: 'replace',
      // inherit the current params on the url
      inherit: true
    });
    this.getInvestigadores();
  };

  openFilter = () => {
    let result = this.filtersLoaded.reduce((a, b) => a + b, 0);

    if (result !== this.filtersLoaded.length) {
      this.UI.addToast("A carregar dados para filtragem, por favor tente novamente");
      return;
    }

    if (!this.nacionalidades.length && !this.generos.length) {
      this.UI.addToast("Erro ao carregar dados de filtragem. Por favor recarregue a página.");
      return;
    }

    this.columns.forEach(f => {
      if (f.id === 'Investigador.generoId')
        f.list = this.generos;
      if (f.id === 'Investigador.nacionalidadeId')
        f.list = this.nacionalidades;
      if (f.id === 'Investigador.ok')
        f.list = this.simnao;
      if (f.id === 'Investigador.superiorHierarquico1Id')
        f.list = this.superioresHierarquicos;
      if (f.id === 'Investigador.superiorHierarquico2Id')
        f.list = this.superioresHierarquicos;
    });

    // Copy column to be used in
    this.editColumns = angular.copy(this.columns);

    // Restore list to selected
    this.customFilters.forEach(f => {
      if (f.column && f.column.selected) {
        if (f.column.selected.id === 'Investigador.generoId')
          f.column.selected.list = this.generos;
        if (f.column.selected.id === 'Investigador.nacionalidadeId')
          f.column.selected.list = this.nacionalidades;
        if (f.column.selected.id === 'Investigador.ok')
          f.column.selected.list = this.simnao;
        if (f.column.selected.id === 'Investigador.superiorHierarquico1Id')
          f.column.selected.list = this.superioresHierarquicos;
        if (f.column.selected.id === 'Investigador.superiorHierarquico2Id')
          f.column.selected.list = this.superioresHierarquicos;
      }
    });
    // Copy customFilter to another variable so we can edit it all we want
    this.editCustomFilters = angular.copy(this.customFilters);
    // Show side panel
    this.fs = true;
  };

  oldColumn = ($item, i) => {
    //Infinite Scroll Magic
    i.infiniteScroll = {};
    i.infiniteScroll.numToAdd = 20;
    i.infiniteScroll.currentItems = 20;

    if ($item.type === 's')
      i.value = {};
    else
      i.value = "";

    i.addMoreItems = function () {
      i.infiniteScroll.currentItems += i.infiniteScroll.numToAdd;
    };
  };

  applyFilter = () => {
    // Parse values from sidebar
    this.editCustomFilters = _.filter(this.editCustomFilters, f => f.column && !_.isEmpty(f.value));

    // Remove list for column, no need to save it
    this.editCustomFilters.forEach(f => {
      if (f.column && f.column.selected) {
        f.column.selected.list = [];
      }
      // Fix date filters to be moment()
      if (f.column.selected.type === 'd') {
        f.value = moment(f.value).utc();
        f.value.second(0); // We don't care about seconds
      }
    });

    this.customFilters = angular.copy(this.editCustomFilters);

    this.setToLocalStorage('ISR_SGI_Filters', 'investigador', this.customFilters);
    this.fs = false;
    // Go to first page for results
    this.opt.page = 1;
    this.$state.go('app.investigator.list', this.opt, {
      // prevent the events onStart and onSuccess from firing
      notify: false,
      // prevent reload of the current state
      reload: false,
      // replace the last record when changing the params so you don't hit the back button and get old params
      location: 'replace',
      // inherit the current params on the url
      inherit: true
    });

    this.getInvestigadores();
  };

  hasSelect = () => {
    return _.some(this.investigadores, a => a.selected === true);
  };

  selectAll = () => {
    if (this.allSelected) { // Not all are selected, select all
      this.investigadores.forEach(a => {
        a.selected = true;
      });
      this.nSelected = this.investigadores.length;
    } else { // Remove all selections
      this.investigadores.forEach(a => {
        a.selected = false;
      });
      this.nSelected = 0;
    }
    this.everythingSelected = false;
  };

  selectEverything = (type) => {
    if (!type) {
      this.investigadores.forEach(a => {
        a.selected = false;
      });
      this.nSelected = 0;
      this.allSelected = false;
    }
    this.everythingSelected = !!type;
  };

  selectItem = () => {
    this.nSelected = _.filter(this.investigadores, r => r.selected).length;
    this.allSelected = this.nSelected >= this.investigadores.length;
    this.everythingSelected = false;
  };

  // Publicacoes

  importPublicacoes = (orcidId, nome) => {
    if (!this.InvestigatorService.isValidOrcidId(orcidId)) {
      this.UI.addToast("ORCID ID do investigador inválido");
      return;
    }
    let wait = this.UI.showWaiting();
    this.Publicacao.getPublicacoesByOrcidId({orcidId: orcidId}).$promise.then((data) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./import.publicacoes.dialog.html'),
        controller: ['$dialog', '$scope', (dialog, scope) => {
          scope.title = "Importar Publicações" + (nome ? ` - ${nome}` : '');
          scope.publicacoes = data.data;
          scope.allSelected = false;


          scope.selectAll = () => {
            scope.allSelected = !scope.allSelected;
            if (scope.allSelected) {
              for (let i = 0; i < scope.publicacoes.length; i++) {
                scope.publicacoes[i].importing = true;
              }
            } else {
              for (let i = 0; i < scope.publicacoes.length; i++) {
                scope.publicacoes[i].importing = false;
              }
            }
          };

          scope.ok = () => {
            dialog.close(scope);
          };

          scope.cancel = () => {
            dialog.dismiss('cancel');
          };
        }]
      };

      let modal = this.UI.showDialog(options);

      modal.then((res) => {
        let importing = res.publicacoes.filter(x => x.importing);
        importing = importing.map(x => {return {orcidBaseId: x.orcidBaseId, putCode: x.putCode, doiShort: x.doiShort, titulo: x.titulo};});
        if (importing.length > 0) {
          wait = this.UI.showWaiting();
          this.Publicacao.importPublicacoes({data: importing}).$promise.then(data => {
            wait.close();
            if (data.errors && data.errors.length > 0) { // Errors happened, show details
              let total = importing.length;
              let numErros = data.errors.filter(x => x.error === true).length;
              let numWarnings = data.errors.filter(x => x.error === false).length;
              let ok = total - numErros - numWarnings;

              let title = `Importação - ${total} Publicaç${total === 1 ? 'ão' : 'ões'} - ${numWarnings} aviso${numWarnings === 1 ? '' : 's'}, ${numErros} erro${numErros === 1 ? '' : 's'}`;
              let introText = `Fo${ok === 1 ? 'i' : 'ram'} importada${ok === 1 ? '' : 's'} ${ok} publicaç${ok === 1 ? 'ão' : 'ões'} com sucesso, tendo ocorrido ${data.errors.length} erro${data.errors.length === 1 ? '' : 's'}:`;
              let instance = this.UI.showDialog({
                size: 'md',
                template: require('../../interface/modals/show-list.html'),
                controller: ['$scope', ($scope) => {
                  $scope.title = title;
                  $scope.introText = introText;
                  $scope.list = data.errors;
                  $scope.ok = function () {
                    $scope.$close();
                  };
                }]
              });
              instance.finally(() => {
                // Nothing should happen
              });
            } else { // No errors were found, just show message
              let okString = (importing.length === 1 ? (`1 publicação importada com sucesso`) : (`${importing.length} publicações importadas com sucesso`));
              this.UI.showAlert(okString);
            }
          }).catch(error => {
            console.log(error);
            this.UI.addToast("Erro de importação. Por favor tente novamente");
          });
        } else {
          this.UI.addToast("Nada a importar");
        }
      });
    }).catch(error => {
      console.log(error);
      this.UI.addToast("Não foi possível obter publicações. Verifique a ligação");
    })
  };

  // If import button is available - canRead can be used
  canImportPublicacao = (investigador) => this.InvestigatorService.canImportFor(investigador);

  deleteInvestigador = (investigador) => {
    this.InvestigatorService.confirmDeleteInvestigador(investigador).then(() => {
      this.getInvestigadores();
    }).catch(error => {
      console.log(error);
      this.getInvestigadores();
    });
  };
}

InvestigatorListController.$inject = ['$state', 'Group', 'UIService', 'Investigador', 'InvestigatorService', 'Pais', 'Genero', 'Publicacao', 'PublicacaoService', 'AuthorizationService', 'AuthenticationService'];
